import { Module, Mutation, VuexModule } from "vuex-module-decorators";

import { store } from "~/store";

@Module({
  name: "AppStatusModule",
  stateFactory: true,
  namespaced: true,
  dynamic: true,
  store,
})
export default class AppStatusModule extends VuexModule {
  isGiveawayPage = false;

  isLayoutDisabled = false;
  usesDarkTheme = false;

  currentlyVisitedProductId: string | null = null;
  previouslyVisitedPagePath: string | null = null;

  get getPreviouslyVisitedPagePath() {
    return this.previouslyVisitedPagePath;
  }

  get getIsLayoutDisabled() {
    return this.isLayoutDisabled;
  }

  get getUsesDarkTheme() {
    return this.usesDarkTheme;
  }

  get getIsGiveawayPage() {
    return this.isGiveawayPage;
  }

  @Mutation
  setPreviouslyVisitedPagePath(pagePath: string | null): void {
    this.previouslyVisitedPagePath = pagePath;
  }

  @Mutation
  setIsLayoutDisabled(newStatus: boolean) {
    this.isLayoutDisabled = newStatus;
  }

  @Mutation
  setIsGiveawayPage(newStatus: boolean) {
    this.isGiveawayPage = newStatus;
  }

  @Mutation
  setUsesDarkTheme(newStatus: boolean) {
    this.usesDarkTheme = newStatus;
  }
}
